import { Component, Input } from "@angular/core";
import { ArticleForUpdateDto, ArticlesLexiClient, TarifDto, TypeTaxe } from "@lexi-clients/lexi";
import { formatNumber } from "devextreme/localization";
import { lastValueFrom } from "rxjs";

@Component({
    selector: "app-tarif-article-simplifie",
    templateUrl: "./tarif-article-simplifie.component.html",
    styleUrls: ["./tarif-article-simplifie.component.scss"],
    standalone: false
})
export class TarifArticleSimplifieComponent {
  protected readonly TypeTaxe = TypeTaxe;
  protected readonly formatNumber = formatNumber;
  tarifs: TarifDto[];
  isModeAvance: boolean = false;
  isTarifsDuParent: boolean = false;

  private _article: ArticleForUpdateDto;
  get article(): ArticleForUpdateDto { return this._article; }
  @Input() set article(value: ArticleForUpdateDto) {
    this._article = value;
    if (value != null) {
      this.setTarifs();
    }
  }

  private _pmpArticle: number;
  get pmpArticle(): number { return this._pmpArticle; }
  @Input() set pmpArticle(value: number) {
      this._pmpArticle = value;
  }

  showPopover: boolean = false;

  constructor(private readonly articlesLexiClient: ArticlesLexiClient) {}

  async setTarifs() {
    this.tarifs = await lastValueFrom(this.articlesLexiClient.getTarifsByArticleId(this.article.id));

    // Si c'est une variante sans tarifs, on récupère le tarif du parent
    if ((this.tarifs == null || this.tarifs.length == 0) && this.article.articleParentId != null) {
      this.tarifs = await lastValueFrom(this.articlesLexiClient.getTarifsByArticleId(this.article.articleParentId));
      this.isTarifsDuParent = this.tarifs != null && this.tarifs.length > 0;
    }
    else {
      this.isTarifsDuParent = false;
    }
  }

  showModeAvance() {
    this.isModeAvance = !this.isTarifsDuParent;
  }

  hideModeAvance() {
    this.isModeAvance = false;
  }
}
